import React, {useEffect, useState} from "react";
import {Accordion, Card, useAccordionButton} from "react-bootstrap";
import {useSelector} from "react-redux";
import ApiConnect from "../../../Utils/ApiConnect";
import NgLoading from "../NgLoading";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);
  return (
    <div className="row w-100" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}
function Voucher(props) {
  const [voucherData, SetvoucherData] = useState(false);
  console.log(props);
  const company = useSelector((state) => state.Auth.company);
  useEffect(() => {
    ApiConnect.get(`/Module/Vouchers/Main/Details?id=${props.id}`).then(
      (response) => {
        SetvoucherData(response.data);
      }
    );
  }, [props]);
  return (
    <>
      {voucherData ? (
        <div className="container print_invoice">
          <div className="print_invoice-header">
            <div className="row">
              <div className="col-xs-6">
                <div className="media">
                  <div className="media-left">
                    <img
                      src={company.Logo}
                      alt={company.Name}
                      width={100}
                      height={100}
                      className="media-object logo"
                    />
                  </div>
                  <ul className="media-body list-unstyled text-center">
                    <li>
                      <h3 style={{ marginBottom: "-2px" }}>{company.Name}</h3>
                    </li>
                    <li>
                      {company.Address} {company.Contact}
                    </li>
                    <li>VAT No: {company.Vatpan}</li>
                  </ul>
                </div>
                <center>
                  <u>
                    <b>
                      <h3>{props.type}</h3>
                    </b>
                  </u>
                </center>
              </div>
              <div className="col-xs-6" style={{ marginLeft: "10%" }}>
                {props.type.toUpperCase() !== "JOURNAL" ? (
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <ul className="media-body list-unstyled">
                        <li>
                          Name : {"{"}accounthead{"}"}
                        </li>
                        <li>
                          Address : {"{"}accounthead_address{"}"}
                        </li>
                        <li>
                          Phone : {"{"}accounthead_contact{"}"}
                        </li>
                        <li>
                          VAT No : {"{"}accounthead_vat{"}"}
                        </li>
                      </ul>
                      <ul className="media-body list-unstyled">
                        <li>
                          Voucher No: {"{"}invoice{"}"}
                        </li>
                        <li>
                          Payment Type: {"{"}payment_type{"}"}
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <br />
          </div>
          <div className="print_invoice-body">
            <div className="row"></div>
            <div className="panel panel-default">
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr>
                    <th className="text-center colfix">Date</th>
                    <th>Particulars</th>
                    <th className="text-center colfix">Debit</th>
                    <th className="text-center colfix">Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {voucherData.map((vch, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <span className="mono">{vch.miti}</span>
                        <br />
                        <span className="mono">{vch.date}</span>
                      </td>
                      <td className="text-left">
                        <span className="mono">{vch.particular}</span>
                      </td>
                      <td className="text-center">
                        <span className="mono">{vch.DrAmount}</span>
                      </td>
                      <td className="text-center">
                        <span className="mono">{vch.CrAmount}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="container">
              <b>In Words:</b> {voucherData[0].inword} <br />
              <i>Comments / Notes</i>: {voucherData[0].notes}
            </div>
            <hr />
            <p className="text-center">
              Thank you for choosing our services.We hope to see you again soon{" "}
              <strong>~{company.Name}~</strong>
            </p>
            {voucherData[0].attachment &&
            voucherData[0].attachment.length !== 0 ? (
              <Accordion>
                <Card key={1}>
                  <Card.Header>
                    <CustomToggle eventKey={1}>
                      <h4 className="col card-title">Attachments</h4>
                      <h4 className="col card-title d-flex flex-row">
                        <span className="material-icons text-success">
                          file
                        </span>
                      </h4>
                    </CustomToggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={1}>
                    <Card.Body>
                      {voucherData[0].attachment.map((images, index) => (
                        <img
                          src={images}
                          key={index}
                          className="rounded"
                          alt={index}
                        />
                      ))}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        <NgLoading />
      )}
    </>
  );
}

export default React.memo(Voucher);
